import { Operation } from "fast-json-patch";
const PatchOp = {
  add: (path: string, value?: any): Operation => ({ op: "add", path, value }),
  remove: (path: string): Operation => ({ op: "remove", path }),
  replace: (path: string, value: any): Operation => ({ op: "replace", path, value }),
  copy: (path: string, from: string): Operation => ({ op: "copy", path, from }),
  move: (path: string, from: string): Operation => ({ op: "move", path, from }),
  test: (path: string, value: any): Operation => ({ op: "test", path, value }),
};

export { PatchOp };
